<template>
  <Transition name="fade">
    <div v-if="booksDetail.length">
      <div class="book-info" v-for="item in booksDetail" :key="item.index">
        <h2>
          {{ item.booksTitle }}
        </h2>
        <!--  <p>120+人喜欢</p> -->
        <div class="book-price">
          <div class="old-price">
            <h3>原价：</h3>
            <h3>&yen;{{ item.booksPrice * booksNum }}</h3>
          </div>
          <div class="sale-price">
            <h3>优惠价：</h3>
            <h3>&yen;{{ item.salePrice * booksNum }}</h3>
          </div>
        </div>
        <div class="contain">
          <h4>出版社：</h4>
          <div class="con-video">
            <i>{{ item.press }}</i>
          </div>
        </div>
        <div class="contain">
          <h4>作者：</h4>
          <div class="con-video">
            <i>{{ item.booksAuthor }}</i>
          </div>
        </div>
        <!--  <div class="delivery">
          <span>配送：</span>
          <div class="delivery-info">
            <ShCity @change="changeCity" :fullLocation="fullLocation" />
          </div>
        </div> -->

        <div class="buy-num">
          <span>数量:</span>
          <div class="number">
            <el-input-number
              v-model="booksNum"
              :min="1"
              class="mx-4"
              @change="numChange"
            />
          </div>
        </div>
        <div class="price">
          <RouterLink
            target="_blank"
            @click="toBuy(item.id, item.clID)"
            :to="`/user/checkout?id=${item.id}&num=${booksNum}&type=book`"
          >
            <el-button size="large" type="danger">点击购买</el-button>
          </RouterLink>
          <!-- <el-button size="large" type="danger" plain>加入购物车</el-button> -->

          <el-button size="large" plain>在线咨询</el-button>
        </div>
        <div class="share">
          <h4>分享到</h4>
          <img src="../../../../public/icon/微信logo.png" alt="" />
          <img src="../../../../public/icon/QQlogo.png" alt="" />
          <img src="../../../../public/icon/QQ空间logo.png" alt="" />
          <img src="../../../../public/icon/微博logo.png" alt="" />
        </div>
      </div>
    </div>
    <BookDetailSkeleton v-else />
  </Transition>
</template>

<script>
import { ref } from "vue";
//import ShCity from "../../../components/library/sh-city.vue";
import BookDetailSkeleton from "./book-detail-skeleton.vue";
export default {
  components: {
    BookDetailSkeleton,
  },
  props: {
    booksDetail: {
      type: Array,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    const booksNum = ref(1);
    //省市县选择组件
    const provinceCode = ref("110000");
    const cityCode = ref("119900");
    const countyCode = ref("110101");
    const fullLocation = ref("北京市 市辖区 东城区");
    //选择城市函数
    const changeCity = (result) => {
      provinceCode.value = result.provinceCode;
      cityCode.value = result.cityCode;
      countyCode.value = result.countyCode;
      fullLocation.value = result.fullLocation;
    };
    //图书数量选择组件
    const numChange = () => {};

    return { fullLocation, changeCity, numChange, booksNum };
  },
};
</script>

<style lang="less" scoped>
.book-info {
  margin-top: 10px;
  width: 780px;
  position: relative;
  //height: 500px;
  //background: #f5f5f5;
  h2 {
    display: -webkit-box;
    max-height: 75px;
    word-break: break-all;
    -webkit-line-clamp: 2;
    text-overflow: ellipsis;
    overflow: hidden;
    -webkit-box-orient: vertical;
  }
  p {
    margin-top: 10px;
    color: #999;
  }
  .book-price {
    display: flex;
    margin-top: 15px;
    align-items: center;
    height: 50px;
    width: 690px;
    .old-price {
      display: flex;
      align-items: center;
      h3 {
        text-decoration: line-through;
      }
    }
    .sale-price {
      display: flex;
      align-items: center;
      margin-left: 25px;
      h3 {
        color: red;
      }
    }
  }
  .contain {
    display: flex;
    align-items: center;
    width: 100%;
    //height: 75px;
    max-height: 115px;
    flex-wrap: wrap;
    border-bottom: 1px dashed #ebebeb;
    h4 {
      width: 70px;
    }
    .con-video {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      width: 620px;
      //padding-top: 10px;
      i {
        display: block;

        //width: 85px;
        padding-left: 5px;
        padding-right: 5px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        margin: 3px 3px 3px 3px;
        color: @shColor;
        background-color: rgb(245, 245, 245);
        border-radius: 5px;
      }
    }
  }
  .delivery {
    display: flex;
    margin-top: 25px;
    align-items: center;
    span {
      color: #999;
    }
    .delivery-info {
      margin-left: 15px;
    }
  }
  .bscontent {
    display: flex;
    margin-top: 30px;
    align-items: center;
    span {
      color: #999;
    }
    .content-item {
      margin-left: 26px;
    }
  }
  .buy-num {
    display: flex;
    margin-top: 30px;
    align-items: center;
    span {
      color: #999;
    }
    .number {
      margin-left: 26px;
    }
  }
  .price {
    display: flex;
    align-items: center;
    justify-content: space-around;
    height: 50px;
    width: 350px;
    margin: 30px auto;
    margin-left: 60px;
  }
  .share {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    //margin-top: 15px;
    border-radius: 8px;
    //height: 35px;
    //background: #f5f5f5;
    h4 {
      margin-right: 15px;
      color: #666;
    }
    img {
      width: 30px;
      height: 30px;
      margin-right: 15px;
      &:hover {
        cursor: pointer;
      }
    }
  }
}
</style>
